import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import FlightsExchangeSearch from 'components/FlightsExchangeSearch';
import HeaderMobile from 'components/HeaderMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';

interface Props {
  show: boolean;
  onClose: () => void;
  onBack: () => void;
  changeDeparture: boolean;
  changeArrival: boolean;
  onSubmit: () => void;
}

const FlightsExchangeSearchContainer = ({ show, onClose, onBack, changeDeparture, changeArrival, onSubmit }: Props) => {
  const { t } = useStoreTranslation();
  const {
    departureCity,
    departureCode,
    departureDate,
    arrivalCity,
    arrivalCode,
    arrivalDate,
    originalFlight,
  } = useSelector((state: RootState) => state.flights.changeFlight);

  const search = () => (
    <FlightsExchangeSearch
      defaultDepartureCity={departureCity}
      defaultDepartureCode={departureCode}
      defaultDepartureDate={departureDate}
      defaultArrivalCity={arrivalCity}
      defaultArrivalCode={arrivalCode}
      defaultArrivalDate={arrivalDate}
      changeDeparture={changeDeparture}
      changeArrival={changeArrival}
      originalFlight={originalFlight}
      onSubmit={onSubmit}
    />
  );

  return (
    <>
      <ApplicationOverlayContent sidebar show={show} onClose={onClose} backgroundColor="#f9f9f9">
        <HeaderMobile goBack={onBack} title={t('flightsExchange.search.header')} onClose={onClose} />
        {search()}
      </ApplicationOverlayContent>
    </>
  );
};

export default FlightsExchangeSearchContainer;
